
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'create': {
    width: 16,
    height: 16,
    viewBox: '0 0 18.002 18.003',
    data: '<path pid="0" d="M0 14.253V18h3.75L14.81 6.94l-3.75-3.75L0 14.253zm17.71-10.21a1 1 0 0 0 0-1.41L15.37.293a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
